import { render, staticRenderFns } from "./image-result.vue?vue&type=template&id=5d07c7d0&scoped=true&"
import script from "./image-result.vue?vue&type=script&lang=ts&"
export * from "./image-result.vue?vue&type=script&lang=ts&"
import style0 from "./image-result.vue?vue&type=style&index=0&id=5d07c7d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d07c7d0",
  null
  
)

export default component.exports